import { render, staticRenderFns } from "./Etapas2.vue?vue&type=template&id=e9d68080"
import script from "./Etapas2.vue?vue&type=script&lang=js"
export * from "./Etapas2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports